import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const BookingList = Loadable(
  lazy(() =>
    import("./bookingList").then(({ BookingList }) => ({
      default: BookingList,
    })),
  ),
);

export const bookingRoutes = [
  {
    path: "/bookings",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.BOOKING]}>
        <BookingList />
      </AuthorizedRoute>
    ),
  },
];
